import { createSlice } from '@reduxjs/toolkit';
import { calculateUnreadNotification, templatesMap } from 'src/components/Notifications/utils';
import { INotificationSlice, NotificationsResponse } from '../components/Notifications/interfaces';

const initialState = {
  notifications: [],
  notificationTemplates: [],
  alerts: [],
  alertTemplates: [],
  unreadNotifications: [],
  isToastShown: false,
  templatesMap: {},
  shouldShowStickyBanner: false,
  showPaymentDoneModal: false,
  paymentDoneModalData: []
} as INotificationSlice;

const notificationSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    setNotificationsData(state, action) {
      const { notifications, notificationTemplates, alerts, alertTemplates } =
        action.payload as NotificationsResponse;
      state.notifications = notifications;
      state.notificationTemplates = notificationTemplates;
      state.alerts = alerts;
      state.alertTemplates = alertTemplates;
      state.unreadNotifications = calculateUnreadNotification(notifications);
      state.templatesMap = templatesMap(notificationTemplates);
    },
    setNotificationToast(state, action) {
      state.isToastShown = action.payload;
    },
    showNotificationStickyBanner(state, action) {
      const { notificationTemplates, notifications } = action.payload;
      const shouldShowStickyBanner = Boolean(notifications?.length);
      // state.shouldShowStickyBanner = shouldShowStickyBanner;
    },
    setPaymentDoneModalData(state, action) {
      state.paymentDoneModalData = [...state.paymentDoneModalData, action.payload];
    },
    setShowPaymentDoneModal(state, action) {
      state.showPaymentDoneModal = !!action.payload;
    },
    clearReadPaymentData(state) {
      state.paymentDoneModalData = state.paymentDoneModalData.filter(item => !item.isRead);
    },
    markPaymentDataRead(state, action) {
      state.paymentDoneModalData = state.paymentDoneModalData.map(item => {
        return {
          ...item,
          isRead: action.payload.includes(item.id)
        };
      });
    }
  }
});

export const {
  setNotificationsData,
  setNotificationToast,
  showNotificationStickyBanner,
  setPaymentDoneModalData,
  setShowPaymentDoneModal,
  clearReadPaymentData,
  markPaymentDataRead
} = notificationSlice.actions;

export default notificationSlice.reducer;
